document.querySelectorAll('.lifeworlds-articles:not(.news-variant)').forEach((element) => {
  // If the brick has no content/articles or has custom articles, skip it.
  const articles = element.querySelector('.lifeworlds-articles-holder:not(.custom-articles)');
  if (!articles) {
    return;
  }

  const articlesData = articles.dataset;
  const mobileAmount = parseInt(articlesData.mobileAmount);
  let order = articlesData.order;
  let category = articlesData.category;
  let totalAmount = parseInt(articlesData.totalAmount);
  let page = 1;

  const indicatorClasses = element.querySelector('.lds-dual-ring')?.classList;
  const connectionErrorClasses = element.querySelector('.articles-connection-error')?.classList;
  const locale = window.location.pathname.split('/')[1];

  // Execute handleOrderButtonClick(), if the new button or the popular button gets clicked.
  const newButton = element.querySelector('.articles-new-button');
  const popularButton = element.querySelector('.articles-popular-button');
  if (newButton && popularButton) {
    newButton.addEventListener('click', () => handleOrderButtonClick(popularButton, newButton, 'newest'));
    popularButton.addEventListener('click', () => handleOrderButtonClick(newButton, popularButton, 'most-popular'));
  }

  /*
    const categoryButtons = document.querySelectorAll('#lifeworldCatList a');
    categoryButtons.forEach((categoryButton) => {
      categoryButton.addEventListener('click', (event) => {
        categoryButtons.forEach((categoryButton) => categoryButton.classList.remove('active'));
        const target = event.target;
        target.classList.add('active');
        const targetData = target.dataset;
        category = targetData.category;
        totalAmount = parseInt(targetData.totalAmount);
        fetchFirstPage();
      });
    });
  */

  // Listen to the click event of the more button, if it exists.
  const moreButton = element.querySelector('.articles-more-button');
  if (!moreButton) {
    return;
  }
  const moreButtonClassList = moreButton.classList;
  moreButton.addEventListener('click', async () => {
    /*
     * If we are on mobile, we want to show the next mobileAmount articles. If we still have articles in the DOM that
     * are invisible on mobile, make them visible first. If we still need more articles after that and more
     * articles are available, continue with normal code execution.
     */
    let currentMobileAmount = 0;
    if (window.innerWidth < 768) {
      currentMobileAmount = mobileAmount;
      element.querySelectorAll('.articles-teaser.d-none').forEach((article) => {
        if (currentMobileAmount === 0) {
          return;
        }
        article.classList.remove('d-none');
        currentMobileAmount--;
      });
      if (element.querySelectorAll('.articles-teaser:not(.d-none)').length === totalAmount) {
        moreButtonClassList.add('d-none');
        return;
      }
      if (currentMobileAmount === 0) {
        return;
      }
    }

    // Fetch the next page of articles.
    page++;
    const response = await fetchPage(currentMobileAmount);

    if (response == null) {
      page--;
      moreButtonClassList.remove('d-none');
      return;
    }
    articles.innerHTML += response;
    if (element.querySelectorAll('.articles-teaser:not(.d-none)').length < totalAmount) {
      moreButtonClassList.remove('d-none');
    }
    if (page * articlesData.amount >= totalAmount) {
      moreButtonClassList.add('d-md-none');
    }
  });

  /**
   * Handles the click event of the new button and the popular button.
   *
   * @param oldButton Button that should no longer be active. Should be the new button, if the popular button was
   *                  clicked, and the popular button, if the new button was clicked.
   * @param newButton Button that was clicked.
   * @param newOrder New order for articles depending on the button that was clicked. Should be "newest" or
   *                 "most-popular."
   */
  function handleOrderButtonClick(oldButton, newButton, newOrder) {
    // Mark the button that was clicked as active.
    oldButton.classList.remove('active');
    oldButton.ariaSelected = false;
    newButton.classList.add('active');
    newButton.ariaSelected = true;
    // Fetch the first page of articles for the new order.
    order = newOrder;
    fetchFirstPage();
  }

  async function fetchFirstPage() {
    // Remove all current articles from the HTML.
    articles.innerHTML = '';

    // Fetch the first page of articles.
    page = 1;
    const response = await fetchPage(mobileAmount);

    // Set the HTML to the HTML of the response.
    articles.innerHTML = response;

    // If there has not been a connection error and a more button exists, make the more button visible again.
    if (response !== null && moreButton && totalAmount > mobileAmount) {
      moreButtonClassList.remove('d-none');
      moreButtonClassList.toggle('d-md-none', totalAmount <= articlesData.amount);
    }
  }

  /**
   * Fetches the HTML for lebenswelten articles from the server taking into account the current page and order.
   *
   * @param currentMobileAmount Amount of articles that should be shown on mobile.
   * @return HTML of the lebenswelten articles or null if there is a connection error. If there are no more articles
   *         for the current page, an empty string will be returned.
   */
  async function fetchPage(currentMobileAmount) {
    // Show the loading indicator.
    indicatorClasses.remove('d-none');

    // Hide the message that there has been a connection error, if it was visible previously.
    connectionErrorClasses.add('d-none');

    // Make the more button invisible during fetching, if it exists.
    if (moreButton) {
      moreButtonClassList.add('d-none');
    }

    const query =
      `?order=${order}&period=${articlesData.period}&amount=${articlesData.amount}&page=${page}` +
      `&categories=${articlesData.categories}&mobile_amount=${currentMobileAmount}` +
      `&compact=${articlesData.compact}&bg_class=${articlesData.bgClass}&items_headline_tag=${articlesData.itemsHeadlineTag}`;
    let url = `/${locale}/`;
    if (category) {
      url += `professionals-news${query}&category=${category}`;
    } else {
      url +=
        `lebenswelten-article-teasers-big${query}&path=${articlesData.path}` +
        `&article_type=${articlesData.articletype}&redesign=true`;
    }

    // Actually fetch the HTML.
    let response = null;
    try {
      response = await (await fetch(url)).text();
    } catch {
      // If an error occurs, make the message that there has been a connection error visible.
      connectionErrorClasses.remove('d-none');
    }

    // Hide the loading indicator again.
    indicatorClasses.add('d-none');

    // Return the content of the response.
    return response;
  }
});
